class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = null;
    this.inner = null;
    this.closeButton = null;
    this.activeElement = null;
    this.closeTimeout = null;
    this.isBound = false;

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.stopInnerClick = this.stopInnerClick.bind(this);
  }

  connectedCallback() {
    this.notification = this.querySelector('#cart-notification') || document.getElementById('cart-notification');
    if (!this.notification || this.isBound) return;

    this.inner = this.notification.querySelector('.cart-notification__inner');
    this.closeButton = this.notification.querySelector('.cart-notification__close');

    this.notification.addEventListener('keyup', this.handleKeyUp);
    this.notification.addEventListener('click', this.handleBackdropClick);

    if (this.inner) {
      this.inner.addEventListener('click', this.stopInnerClick);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleCloseButtonClick);
    }

    this.isBound = true;
  }

  disconnectedCallback() {
    if (!this.notification) return;

    this.notification.removeEventListener('keyup', this.handleKeyUp);
    this.notification.removeEventListener('click', this.handleBackdropClick);

    if (this.inner) {
      this.inner.removeEventListener('click', this.stopInnerClick);
    }

    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleCloseButtonClick);
    }

    this.isBound = false;
  }

  handleKeyUp(event) {
    if (event.code === 'Escape' || event.key === 'Escape') {
      this.close();
    }
  }

  handleBackdropClick(event) {
    if (event.target === this.notification) {
      this.close();
    }
  }

  handleCloseButtonClick(event) {
    event.preventDefault();
    this.close();
  }

  stopInnerClick(event) {
    event.stopPropagation();
  }

  open() {
    if (!this.notification) return;

    window.clearTimeout(this.closeTimeout);

    this.notification.removeAttribute('hidden');
    document.body.classList.add('cart-notification-open');

    this.notification.classList.remove('active');
    void this.notification.offsetWidth;
    this.notification.classList.add('animate');

    requestAnimationFrame(() => {
      this.notification.classList.add('active');
    });

    window.setTimeout(() => {
      try {
        this.notification.focus();
        if (typeof trapFocus === 'function') {
          trapFocus(this.notification);
        }
      } catch (error) {}
    }, 240);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.classList.remove('cart-notification-open');

    try {
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
    } catch (error) {}

    window.clearTimeout(this.closeTimeout);

    this.closeTimeout = window.setTimeout(() => {
      this.notification.setAttribute('hidden', '');
    }, 240);
  }

  renderContents(parsedState) {
    this.renderProduct(parsedState);
    this.renderSectionInto(parsedState, 'cart-notification-button', 'cart-notification-button');
    this.decorateActions();
    this.bindContinueShopping();
    this.open();
  }

  bindContinueShopping() {
    const continueButton = this.querySelector('.cart-notification__action--secondary');
    if (!continueButton) return;

    if (continueButton.dataset.bound === 'true') return;
    continueButton.dataset.bound = 'true';

    continueButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.close();
    });
  }

  decorateActions() {
    const container = document.getElementById('cart-notification-button');
    if (!container) return;

    const elements = [...container.querySelectorAll('a, button')].filter((element) => {
      if (element.classList.contains('cart-notification__close')) return false;
      if (!element.textContent || !element.textContent.trim()) return false;
      return true;
    });

    if (!elements.length) return;

    let cartButton = null;
    let continueButton = null;

    elements.forEach((element) => {
      const text = element.textContent.trim().toLowerCase();
      const href = (element.getAttribute('href') || '').toLowerCase();

      if (
        href.includes('/cart') ||
        text.includes('cart') ||
        text.includes('колич')
      ) {
        cartButton = element;
      } else {
        continueButton = element;
      }
    });

    if (!cartButton) {
      cartButton = elements[0];
    }

    if (!continueButton) {
      continueButton = elements.find((el) => el !== cartButton) || null;
    }

    container.innerHTML = '';

    if (cartButton) {
      cartButton.classList.remove('cart-notification__action--secondary');
      cartButton.classList.add('cart-notification__action--primary');
      cartButton.textContent = 'Към количката';
      container.appendChild(cartButton);
    }

    if (continueButton) {
      continueButton.classList.remove('cart-notification__action--primary');
      continueButton.classList.add('cart-notification__action--secondary');
      continueButton.textContent = 'Пазарувай още';
      continueButton.setAttribute('href', '#');
      container.appendChild(continueButton);
    }
  }

  renderProduct(parsedState) {
    const target = document.getElementById('cart-notification-product');
    const html = parsedState?.sections?.['cart-notification-product'];
    if (!target || !html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const key = parsedState?.key;
    let itemElement = null;

    if (key) {
      itemElement = doc.querySelector(`#cart-notification-product-${CSS.escape(key)}`);
    }

    if (!itemElement) {
      const allItems = doc.querySelectorAll('[id^="cart-notification-product-"]');
      itemElement = allItems.length ? allItems[allItems.length - 1] : null;
    }

    if (!itemElement) {
      const sectionElement = doc.querySelector('.shopify-section');
      target.innerHTML = sectionElement ? sectionElement.innerHTML : doc.body.innerHTML;
      return;
    }

    target.innerHTML = itemElement.innerHTML;
  }

  renderSectionInto(parsedState, sectionKey, targetId) {
    const target = document.getElementById(targetId);
    const html = parsedState?.sections?.[sectionKey];
    if (!target || !html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sectionElement = doc.querySelector('.shopify-section');

    target.innerHTML = sectionElement ? sectionElement.innerHTML : doc.body.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}